import { reaction, runInAction, makeAutoObservable } from 'mobx';
import { AuthenticationStore } from './AuthenticationStore';
import { Gym, GymApi } from '../Model/Gym/Gym';
import { logger } from '../Utils/logger';
import { Customer, CustomerApi } from '../Model/Customer';
import { AnalyticsStore } from './Firebase/AnalyticsStore';

function createGymCustomerStore(authentication: AuthenticationStore, analytics: AnalyticsStore) {
  const store = makeAutoObservable({
    authentication,
    analytics,
    currentGym: undefined as Gym | undefined,
    customer: undefined as Customer | undefined,

    setGymIdUserProperty(customer: Customer) {
      if (customer.gymId !== 'flinq') {
        logger('GymCustomerStore:setGymIdUserProperty', customer.gymId);
        this.analytics.setUserProperty('gymId', customer.gymId);
      }
    },

    fetchCurrentGym(): Promise<Gym | undefined> {
      return GymApi.currentGym().then((gym) => {
        runInAction(() => (this.currentGym = gym));
        return gym;
      });
    },
  });

  reaction(
    () => authentication.athleteId,
    (athleteId) => {
      if (athleteId) {
        CustomerApi.recentCoachCustomer().then((res) => runInAction(() => (store.customer = res)));
      } else {
        runInAction(() => (store.customer = undefined));
      }
    },
  );

  reaction(
    () => authentication.athleteId,
    (athleteId) => {
      if (athleteId) {
        store.fetchCurrentGym();
      } else {
        runInAction(() => (store.currentGym = undefined));
      }
    },
    {
      fireImmediately: true,
      name: 'Fetch gyms',
    },
  );

  reaction(
    () => store.customer,
    (customer) => {
      if (customer) {
        store.setGymIdUserProperty(customer);
      }
    },
    { name: 'set gymId', fireImmediately: true },
  );

  return store;
}

export type GymCustomerStore = ReturnType<typeof createGymCustomerStore>;
export const createGymCustomerStoreInstance = createGymCustomerStore;
